var GroupContractBuilderErrors = {

  general: function (errors) {
    var err = [];

    if (errors.base && errors.base.length) {
      for (var i = 0, ilen = errors.base.length; i < ilen; i++) {
        err.push(errors.base[i]);
      }
    }

    var field_names = [
            'code',
            'description',
            'start_date',
            'end_date',
            'name'];

    for (var i = 0, ilen = field_names.length; i < ilen; i++) {
      var field_errors = errors[field_names[i]];
      if (field_errors && field_errors.length) {
        for (var j = 0, jlen = field_errors.length; j < jlen; j++) {
          err.push(I18n.t(field_names[i]) + ' ' + field_errors[j]);
        }
      }
    }

    return err;
  },

  pricing: function (errors) {
    var err = []
    var field_names = []

    for (var i = 0, ilen = field_names.length; i < ilen; i++) {
      var field_errors = errors[field_names[i]]
      if (field_errors && field_errors.length) {
        for (var j = 0, jlen = field_errors.length; j < jlen; j++) {
          err.push(I18n.t(field_names[i]) + ' ' + field_errors[j])
        }
      }
    }

    return err
  },

  rates: function (errors) {
    var err = []
    var field_names = []

    for (var i = 0, ilen = field_names.length; i < ilen; i++) {
      var field_errors = errors[field_names[i]]
      if (field_errors && field_errors.length) {
        for (var j = 0, jlen = field_errors.length; j < jlen; j++) {
          err.push(I18n.t(field_names[i]) + ' ' + field_errors[j])
        }
      }
    }

    return err;
  },

  notes: function (errors) {
    var err = []
    var field_names = []

    for (var i = 0, ilen = field_names.length; i < ilen; i++) {
      var field_errors = errors[field_names[i]]
      if (field_errors && field_errors.length) {
        for (var j = 0, jlen = field_errors.length; j < jlen; j++) {
          err.push(I18n.t(field_names[i]) + ' ' + field_errors[j])
        }
      }
    }

    return err
  },
}
export default GroupContractBuilderErrors